import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../../api/client';

export interface GiftCardDto {
  giftCardId: string;
  code: string;
  initialBalance: number;
  currentBalance: number;
  customerId: string | null;
  customerName: string | null;
  expiryDate: string | null;
  isActive: boolean;
  notes: string | null;
  createdAt: string;
}

export interface IssueGiftCardRequest {
  code?: string | null;
  initialBalance: number;
  customerId?: string | null;
  expiryDate?: string | null;
  notes?: string | null;
}

const QK = ['gift-cards'] as const;

export function useGiftCards(includeInactive: boolean) {
  return useQuery({
    queryKey: [...QK, includeInactive],
    queryFn: async () =>
      (await apiClient.get<GiftCardDto[]>('/api/gift-cards', { params: { includeInactive } })).data,
  });
}

export function useIssueGiftCard() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (req: IssueGiftCardRequest) =>
      (await apiClient.post<GiftCardDto>('/api/gift-cards', req)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}

export function useVoidGiftCard() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await apiClient.post(`/api/gift-cards/${id}/void`, {});
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}
